module.exports = __webpack_public_path__ + "static/img/champion-en.4693978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/champion-en.png
// module id = xSqB
// module chunks = 1